import React from 'react';

import Notification from '@components/lpc/Pot/MainModule/Activity/Notification/Notification';

type ActivityProps = {
    personRole: string;
    potRef: string;
    category: string;
    isOffered: boolean;
};
const Activity = ({ personRole, potRef, category, isOffered }: ActivityProps) => {
    return <Notification isOffered={isOffered} category={category} personRole={personRole} potRef={potRef} />;
};

export default Activity;
